import useTranslationRating from './hooks/useTranslationRating'
import { FormattedMessage } from 'react-intl'
import styles from './TranslationRating.module.scss'
import cx from 'classnames'

import PropTypes from 'prop-types'
import LoadingIndicator from '../LoaderIndicator'
import { useState } from 'react'

export default function TranslationRating({ translationIds }) {
  const { postRating, isLoading } = useTranslationRating()
  const [selected, setSelected] = useState({})
  const handleTranslateRating = (e, values) => {
    if(e.target.className.includes('-up')) {
      setSelected({ up: true })
    } else {
      setSelected({ down: true })
    }
    const { pathname, origin } = window.location
    const currentUrl = `${origin}${pathname}`
    postRating({
      ...values,
      url: currentUrl,
      translationIds,
    })
  }
  return (
    <div className={styles.rating}>
      <p className={styles.text}>
        <span>
          <FormattedMessage
            defaultMessage='<sup>*</sup>This content has been translated using AI/ ML.'
            values={{ sup: (text) => <sup>{text}</sup> }}
          />
          &nbsp;
          <FormattedMessage defaultMessage='Is the translation on this page high quality?' />
        </span>
        {isLoading ? (
          <LoadingIndicator customStyles={styles.loader} />
        ) : (
          <span className={styles.icons}>
            <i
              className={cx('font-icons icon-thumbs-up', {
                [styles.selected]: selected.up,
              })}
              onClick={(e) => handleTranslateRating(e, { rating: 1 })}
            />
            <i
              className={cx(styles.down, 'font-icons icon-thumbs-down', {
                [styles.selected]: selected.down,
              })}
              onClick={(e) => handleTranslateRating(e, { rating: -1 })}
            />
          </span>
        )}
      </p>
    </div>
  )
}

TranslationRating.propTypes = {
  translationIds: PropTypes.array,
}
